export const DEFAULT_NAMESPACE = 'default';

export const MasonryEngineLevelActionNames = ['onLoad'];
